import { IconType } from "./icons.types";

export const FileIcon = ({
  className,
  color = "var(--primary-color)",
}: IconType) => {
  return (
    <svg
      width="29"
      height="42"
      viewBox="0 0 29 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M23.3087 34.0668H6.15082C5.93632 34.0668 5.7306 33.9816 5.57893 33.8299C5.42725 33.6782 5.34204 33.4725 5.34204 33.258C5.34204 33.0435 5.42725 32.8378 5.57893 32.6861C5.7306 32.5344 5.93632 32.4492 6.15082 32.4492H23.3098C23.5243 32.4492 23.73 32.5344 23.8817 32.6861C24.0334 32.8378 24.1186 33.0435 24.1186 33.258C24.1186 33.4725 24.0334 33.6782 23.8817 33.8299C23.73 33.9816 23.5243 34.0668 23.3098 34.0668H23.3087Z"
        fill="url(#paint0_linear_939_11773)"
      />
      <path
        d="M23.3087 27.602H6.15082C5.93632 27.602 5.7306 27.5167 5.57893 27.3651C5.42725 27.2134 5.34204 27.0077 5.34204 26.7932C5.34204 26.5787 5.42725 26.3729 5.57893 26.2213C5.7306 26.0696 5.93632 25.9844 6.15082 25.9844H23.3098C23.5243 25.9844 23.73 26.0696 23.8817 26.2213C24.0334 26.3729 24.1186 26.5787 24.1186 26.7932C24.1186 27.0077 24.0334 27.2134 23.8817 27.3651C23.73 27.5167 23.5243 27.602 23.3098 27.602H23.3087Z"
        fill="url(#paint1_linear_939_11773)"
      />
      <path
        d="M23.3087 21.1376H6.15082C5.93632 21.1376 5.7306 21.0524 5.57893 20.9007C5.42725 20.749 5.34204 20.5433 5.34204 20.3288C5.34204 20.1143 5.42725 19.9086 5.57893 19.7569C5.7306 19.6052 5.93632 19.52 6.15082 19.52H23.3098C23.5243 19.52 23.73 19.6052 23.8817 19.7569C24.0334 19.9086 24.1186 20.1143 24.1186 20.3288C24.1186 20.5433 24.0334 20.749 23.8817 20.9007C23.73 21.0524 23.5243 21.1376 23.3098 21.1376H23.3087Z"
        fill="url(#paint2_linear_939_11773)"
      />
      <path
        d="M23.3087 14.6727H6.15082C5.93632 14.6727 5.7306 14.5875 5.57893 14.4359C5.42725 14.2842 5.34204 14.0785 5.34204 13.864C5.34204 13.6495 5.42725 13.4437 5.57893 13.2921C5.7306 13.1404 5.93632 13.0552 6.15082 13.0552H23.3098C23.5243 13.0552 23.73 13.1404 23.8817 13.2921C24.0334 13.4437 24.1186 13.6495 24.1186 13.864C24.1186 14.0785 24.0334 14.2842 23.8817 14.4359C23.73 14.5875 23.5243 14.6727 23.3098 14.6727H23.3087Z"
        fill="url(#paint3_linear_939_11773)"
      />
      <path
        d="M27.7963 41.8855H1.04474C0.938611 41.8855 0.833528 41.8646 0.735496 41.824C0.637463 41.7833 0.548401 41.7238 0.473409 41.6487C0.398418 41.5736 0.33897 41.4844 0.298456 41.3863C0.257943 41.2883 0.237163 41.1831 0.237305 41.077V0.922529C0.237305 0.708285 0.322337 0.502799 0.473728 0.351204C0.62512 0.199609 0.830492 0.114301 1.04474 0.114014H20.3921C20.4983 0.113979 20.6034 0.134909 20.7015 0.175601C20.7995 0.216294 20.8886 0.275949 20.9635 0.351142L28.3688 7.75476C28.5203 7.90632 28.6056 8.1118 28.6059 8.32615V41.077C28.6059 41.1833 28.585 41.2885 28.5443 41.3867C28.5036 41.4848 28.4439 41.574 28.3687 41.6491C28.2935 41.7242 28.2043 41.7837 28.106 41.8243C28.0078 41.8649 27.9026 41.8857 27.7963 41.8855ZM1.85379 40.2696H26.9889V8.66366L20.0563 1.72942H1.85379V40.2696Z"
        fill="#E4E4E4"
      />
      <path
        d="M26.4743 8.86926H20.4402C20.3341 8.86926 20.229 8.84833 20.131 8.80769C20.033 8.76704 19.9439 8.70747 19.8689 8.63238C19.7939 8.55728 19.7345 8.46815 19.694 8.37006C19.6534 8.27197 19.6327 8.16686 19.6328 8.06074V1.14874C19.6328 0.934595 19.7179 0.729222 19.8693 0.5778C20.0207 0.426377 20.2261 0.341309 20.4402 0.341309C20.6544 0.341309 20.8598 0.426377 21.0112 0.5778C21.1626 0.729222 21.2477 0.934595 21.2477 1.14874V7.25276H26.4743C26.6886 7.25276 26.8941 7.33789 27.0456 7.48941C27.1971 7.64094 27.2822 7.84645 27.2822 8.06074C27.2822 8.27503 27.1971 8.48054 27.0456 8.63206C26.8941 8.78359 26.6886 8.86871 26.4743 8.86871V8.86926Z"
        fill="#E4E4E4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_939_11773"
          x1="14.7303"
          y1="32.4492"
          x2="14.7303"
          y2="34.0668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_939_11773"
          x1="14.7303"
          y1="25.9844"
          x2="14.7303"
          y2="27.602"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_939_11773"
          x1="14.7303"
          y1="19.52"
          x2="14.7303"
          y2="21.1376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
        <linearGradient
          id="paint3_linear_939_11773"
          x1="14.7303"
          y1="13.0552"
          x2="14.7303"
          y2="14.6727"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={color} />
          <stop offset="1" stopColor={color} />
        </linearGradient>
      </defs>
    </svg>
  );
};
